module.exports = __webpack_public_path__ + "static/img/company_environment.99985a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/company_environment.jpg
// module id = sJu0
// module chunks = 0